import './index.scss'
import { ReactComponent as PuffIcon } from '@/assets/icons/puff.svg'
import Typography from '@/components/ui/Typography'

export type OverlayProps = {
  size?: number
  title?: string
}
export function LoadingOverlay(props: any): JSX.Element {
  return (
    (props.loading && (
      <div className="loading-overlay">
        <div className="lds-dual-ring"></div>
        {props.children}
      </div>
    )) ||
    ''
  )
}

export function LoadingCover(props: any): JSX.Element {
  return (
    (props.loading && (
      <div className="loading-cover">
        <div className="lds-dual-ring"></div>
        {props.children}
      </div>
    )) ||
    ''
  )
}

export function LoadingDiv(props: any): JSX.Element {
  return (
    (props.loading && (
      <div className="loading-div">
        <div className="lds-dual-ring"></div>
        {props.children}
      </div>
    )) ||
    ''
  )
}

export function Puff({ size = 32 }: OverlayProps) {
  return <PuffIcon width={size} height={size} />
}

export function PuffOverlay({ size = 32, title }: OverlayProps) {
  return (
    <div className={'puff-overlay'}>
      <Puff size={size} />
      {title && <Typography variant={'lg'}>{title}</Typography>}
    </div>
  )
}
